import React from "react";
import { Box } from "Components/Base/Layout/Box";
import { Grid } from "Components/Base/Layout/Grid";
import { useDisplayLearningActivityCardImage } from "lib/hocs/useLearningActivityCardState";
import Card from "./Card";
import {
  PROP_TYPE_PROGRAM_CONTENT,
  PROP_DEFAULT_PROGRAM_CONTENT,
} from "../../../../propTypes";

const ProgramCards = (props) => {
  const {
    steps,
    activityId,
    onRefresh,
    programParticipant,
    isPreview,
    isManager,
  } = props;
  const displayCardImage = useDisplayLearningActivityCardImage();

  return (
    <Box sx={{ padding: "32px 0 !important", marginLeft: "16px" }}>
      <Grid container spacing={2} className="program-cards">
        {steps.map((course, index) => {
          const courseWithIndex = { ...course, index };
          return (
            <Card
              course={courseWithIndex}
              order={index}
              displayImage={displayCardImage}
              activityId={activityId}
              onRefresh={onRefresh}
              programParticipant={programParticipant}
              isPreview={isPreview}
              isManager={isManager}
            />
          );
        })}
      </Grid>
    </Box>
  );
};

ProgramCards.propTypes = {
  steps: PROP_TYPE_PROGRAM_CONTENT,
};

ProgramCards.defaultProps = {
  steps: PROP_DEFAULT_PROGRAM_CONTENT,
};

export default ProgramCards;
